import { CategoryDto } from '@careapp-group/ng-sdk';

import { CareAppListActionFactory } from '../action-factory';

class MemoCategoryActions extends CareAppListActionFactory<CategoryDto> {
  readonly RESPONSE_SUCCESS_BY_ORG_ID = `[${this.type}][Response][Success] Retrieve by organisation ID`;
  readonly REQUEST_REMOVE_BY_ID = `[${this.type}][Request] Remove By Id`;
  readonly RESPONSE_SUCCESS_REMOVE_BY_ID = `[${this.type}][Response][Success] Remove By Id`;
  readonly RESPONSE_FAIL_REMOVE_BY_ID = `[${this.type}][Response][Fail] Remove By Id`;
  readonly REQUEST_ADD_BY_ID = `[${this.type}][Request] Add By Id`;
  readonly RESPONSE_SUCCESS_ADD_BY_ID = `[${this.type}][Response][Success] Add By Id`;
  readonly RESPONSE_FAIL_ADD_BY_ID = `[${this.type}][Response][Fail] Add By Id`;

  ResponseSuccessByOrgIdAction(payload: { id: string; data: CategoryDto[] }) {
    return {
      type: this.RESPONSE_SUCCESS_BY_ORG_ID,
      payload,
    };
  }

  RequestRemoveById(payload: { id: string }) {
    return {
      type: this.REQUEST_REMOVE_BY_ID,
      payload,
    };
  }

  ResponseSuccessRemoveById(payload: { organisationId: string; categoryId: string }) {
    return {
      type: this.RESPONSE_SUCCESS_REMOVE_BY_ID,
      payload,
    };
  }

  ResponseFailRemoveById(payload) {
    return {
      type: this.RESPONSE_FAIL_REMOVE_BY_ID,
      payload,
    };
  }

  RequestAddById(payload: { id: string; ordinal?: number }) {
    return {
      type: this.REQUEST_ADD_BY_ID,
      payload,
    };
  }

  ResponseSuccessAddById(payload: { organisationId: string; data: CategoryDto }) {
    return {
      type: this.RESPONSE_SUCCESS_ADD_BY_ID,
      payload,
    };
  }

  ResponseFailAddById(payload) {
    return {
      type: this.RESPONSE_FAIL_ADD_BY_ID,
      payload,
    };
  }

  constructor() {
    super('MemoCategories');
  }
}

export const MemoCategories = new MemoCategoryActions();
